<template>
<div class="form-designer-component" v-cloak v-show="taskObjLoaded">
    <div class="mcc-page-header taskHeader" v-show="!isStandalone">
        <section class="mu-d-flex mu-flex-row">
            <h1 class="mu-mb-00">{{taskObj.processName}}</h1>
            <details class="mcc-popover mcc-popover--bottom-end">
                <summary class="mcc-button mcc-button--icon-only ">
                    <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                </summary>
                <div class="mcc-popover__content">
                    <p class="mu-mb-00">
                        {{ helpText.title }}
                        <a :href="helpText.url" target="_blank">Read more...</a>
                    </p>
                </div>
            </details>
        </section>
        <section>
          
            <div role="group" class="mcc-button-group mcc-button-group--spaced no-print" v-show="fetchCall">
                <button type="button" class="mcc-button mcc-button--soft-success mb-2" :disabled="taskObj.allowClaim || (!taskObj.allowUnClaim && !taskObj.allowClaim && !taskObj.isCompleted) || taskObj.isCompleted" id="saveForLaterBtn" name="saveForLaterBtn" title="Save as draft" @click="handleSaveForLater()">
                    <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save
                        as draft</span>
                </button>
                <div v-if="fetchCall">
                    <div id="dropdown_btn" role="group" class="mcc-button-group" :default-text="claimUnclaimTitle">
                        <button @click="handleClaimUnclaim(claimUnclaimTitle, false)" type="button" class="mcc-button mcc-button--primary mu-mr-00 mb-2" :disabled="taskObj.isCompleted || (!taskObj.isCompleted && !taskObj.allowUnClaim && !taskObj.allowClaim)">
                            <mcc-icon name="check_circle" aria-hidden="true"></mcc-icon>
                            <span class="mcc-button__label">{{claimUnclaimTitle}}</span>
                        </button>
                        <details class="mcc-dropdown mcc-dropdown--sw">
                            <summary :class="!taskObj.allowClaim?'mcc-button mcc-button--outline mu-border-start mcc-button--icon-only':'mcc-button mcc-button--outline mu-border-start mcc-button--icon-only mu-is-disabled'" aria-haspopup="true">
                                <span class="[ mcc-button__label ] [ mu-visually-hidden ]" >Dropdown</span>
                                <mcc-icon class="[ mcc-button__dropdown-caret ] [ mu-m-04 ]" name="expand_arrow" aria-hidden="true"></mcc-icon>
                            </summary>
                            <ul class="mcc-dropdown__menu" v-show="!taskObj.allowClaim">
                                <li @click="closeDropdown">
                                    <button type="button" id="delegateBtn" title="Delegate" @click="$refs.taskOperations.delegateSubmitShowHandler()" v-show="taskObj.isTaskClaimedAndNotCompleted && (taskObj.allowUnClaim == true || taskObj.isAdminUser == true)"><span class="mcc-button__label">Delegate</span></button>
                                    <button type="button" id="reassignBtn" @click="$refs.taskOperations.reAssignSubmitShowHandler()" v-show="taskObj.allowReAssign && !taskObj.isCompleted" title="Reassign"><span class="mcc-button__label">Reassign</span></button>
                                    <button type="button" id="resolveBtn" @click="performResolveOperation($event)" v-show="taskObj.allowResolve && !taskObj.isCompleted" title="Resolve"><span class="mcc-button__label">Resolve</span></button>
                                    
                                </li>
                            </ul>
                        </details>
                    </div>
                </div>
                <details class="mcc-dropdown mcc-dropdown--sw">
                    <summary aria-haspopup="true">
                        <div class="mcc-button mcc-button--outline">
                        <mcc-icon class="mcc-dropdown__toggle-icon" name="menu_2" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">More</span>
                        </div>
                    </summary>
                    <ul class="mcc-dropdown__menu mcc-dropdown-width">
                        <li>
                            <button type="button" class="mcc-button" id="involvedPeopleBtn" v-show="taskObj.allowInvolveUser" @click="involvedUserShowHandlerDialog()" title="People involved">
                                <mcc-icon name="user_account" aria-hidden="true"></mcc-icon><span class="mcc-button__label mu-fw-medium"> People involved
                                <span v-show="involvedUsersCount > 0">({{ involvedUsersCount }})</span>
                                </span>
                            </button>
                        </li>
                        <li>
                            <button type="button" class="mcc-button" id="attachmentBtn" @click="$refs.attachmentDialog.attachmentShowHandler(false)" title="Attachment">
                                <mcc-icon name="attach" aria-hidden="true"></mcc-icon><span class="mcc-button__label mu-fw-medium">Attachment
                                    <span v-show="attachmentCount > 0">({{ attachmentCount }})</span>
                                </span>
                            </button>
                        </li>
                        <li>
                            <button type="button" class="mcc-button" id="commentsBtn" dialog="comments-dialog" @click="$refs.taskHistoryComment.showCommentDialog()" title="Comments">
                                <mcc-icon name="chat" aria-hidden="true"></mcc-icon><span class="mcc-button__label mu-fw-medium">Comments
                                    <span v-show="commentCount > 0">({{ commentCount }})</span>
                                </span>
                            </button>
                        </li>
                        <div class="mu-border-bottom " ></div>
                        <button type="button" class="mcc-button"  id="procDetailsBtn" @click="$refs.processTaskDetails.processDetailsShowHandler()" title="Process details">
                            <mcc-icon name="process" aria-hidden="true"></mcc-icon><span class="mcc-button__label mu-fw-medium">Process details</span>
                        </button>
                        <button type="button" class="mcc-button"  id="taskDetailsBtn" @click="$refs.processTaskDetails.taskDetailsShowHandler()" title="Details">
                            <mcc-icon name="grid" aria-hidden="true"></mcc-icon><span class="mcc-button__label mu-fw-medium">Details</span>
                        </button>
                        <button type="button" class="mcc-button"  id="taskHistoryBtn" dialog="taskHistory-dialog" @click="$refs.taskHistoryComment.showTaskHistoryCommentDialog()" title="Task history">
                            <mcc-icon name="past" aria-hidden="true"></mcc-icon><span class="mcc-button__label mu-fw-medium">Task history</span>
                        </button>
                        <button type="button" class="mcc-button" id="printForm" name="printForm" title="Print" @click="handlePrintForm()">
                            <mcc-icon name="print" aria-hidden="true"></mcc-icon><span class="mcc-button__label mu-fw-medium">Print</span>
                        </button>
                    </ul>
                </details>
            </div>
        </section>
    </div>
    <div :class="isStandalone ? 'mcc-page-header mcc-page-header-standalone' : 'mcc-page-header taskHeader taskerHeaderMargin'" v-if="isStandalone && !isExternal">
        <section class="mu-d-flex mu-flex-column">
            <h1 class="mu-mb-00"></h1>
        </section>
        <section>
            <div role="group" class="mcc-button-group mcc-button-group--spaced" v-show="fetchCall">
                <button type="button" class="mcc-button mcc-button--soft-success" :disabled="taskObj.allowClaim || (!taskObj.allowUnClaim && !taskObj.allowClaim && !taskObj.isCompleted) || taskObj.isCompleted" id="saveForLaterBtn" name="saveForLaterBtn" title="Save as draft" @click="handleSaveForLater()">
                    <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save as draft</span>
                </button>
                <button type="button" class="mcc-button mcc-button--primary" :disabled="taskObj.isCompleted || (!taskObj.isCompleted && !taskObj.allowUnClaim && !taskObj.allowClaim)" id="claimunclaim" @click="handleClaimUnclaim(claimUnclaimTitle, true)" :title="claimUnclaimTitle">
                    <mcc-icon name="check_circle" aria-hidden="true"></mcc-icon><span class="mcc-button__label">{{ claimUnclaimTitle }} </span>
                </button>
            </div>
        </section>
    </div>
    <div :class="isStandalone ? 'mcc-container-fluid card-padding mcc-row-standalone' : 'mcc-container-fluid card-padding'">
        <div  v-if="!isStandalone">
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li v-if="!isLocationProcessEngine">My tasks</li>
                    <li v-if="!isLocationProcessEngine">
                        <a class="table-link" @click="redirectToTaskList()">{{ menu }}</a>
                    </li>
                    <li v-if="isLocationProcessEngine">Process engine</li>
                    <li v-if="isLocationProcessEngine">
                        <a class="table-link" @click="redirectToEngineTaskList()">Tasks</a>
                    </li>
                    <li v-show="taskObj.taskId != ''" aria-current="page">{{ taskObj.taskName + ' (' + taskObj.taskId + ')' }}</li>
                </ol>
            </nav>
        </div>
        <div style="position:relative">
            <div id="typeahead-repeatable-wait" class="spinner-overlay d-none">
                <div class="spinner-background"></div>
                <div class="spinner-flex">
                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                        </circle>
                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                </div>
            </div>
            <div id="typeahead-wait" class="spinner-overlay d-none">
                <div class="spinner-background"></div>
                <div class="spinner-flex">
                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                        </circle>
                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                </div>
            </div>
            <div class="mcc-row" v-if="!fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mcc-row" v-if="fetchCall">
                <div class="mcc-col">
                    
                    <div style="position:relative">
                        <div v-if="!updateCall" class="spinner-overlay">
                            <div class="spinner-background"></div>
                            <div class="spinner-flex">
                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                </svg>
                            </div>
                        </div>
                        <div class="mcc-card">
                            <div class="mcc-row mu-px-06 mu-pt-06" v-if="(!taskObj.allowUnClaim && !taskObj.allowClaim && !taskObj.isAdminUser && !taskObj.isUserInitiator)">
                                <div class="mcc-col">
                                    <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" color="warning">
                                        <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                                        <strong>Warning!</strong>
                                        <div>
                                            <span>This task cannot be claimed.</span>
                                        </div>
                                        <div>
                                            <span>Reason : You are not involved in the task.</span>
                                        </div>
                                    </mcc-alert>
                                </div>
                            </div>
                            <div class="mcc-row mu-px-06 mu-pt-06" v-if="!taskObj.allowUnClaim && !taskObj.isAdminUser && taskObj.isUserInitiator">
                                <div class="mcc-col">
                                    <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" color="warning">
                                        <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                                        <strong>Warning!</strong>
                                        <div>
                                            <span>This task cannot be claimed.</span>
                                        </div>
                                        <div>
                                            <span>Reason : You are not allowed to accept/reject your own requests.</span>
                                        </div>
                                    </mcc-alert>
                                </div>
                            </div>
                            <div class="mcc-row mu-px-06 mu-pt-06" v-if="!taskObj.allowUnClaim && !taskObj.allowClaim && !taskObj.isCompleted && taskObj.email && taskObjLoaded">
                                <div class="mcc-col">
                                    <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact">
                                        <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                                        <strong>Warning!</strong>
                                        <div>
                                            <span>This task cannot be claimed or unclaimed.</span>
                                        </div>
                                        <div>
                                            <span v-if="taskObj.isDelegated">Reason : It is delegated to <a class="table-link" :href="`mailto:${taskObj.email}?subject=Re: ${taskObj.taskName}`">{{ taskObj.assignee }}</a></span>
                                            <span v-if="!taskObj.isDelegated">Reason : It is claimed by <a class="table-link" :href="`mailto:${taskObj.email}?subject=Re: ${taskObj.taskName}`">{{ taskObj.assignee }}</a></span>
                                        </div>
                                    </mcc-alert>
                                </div>
                            
                            </div>
                            
                            
                            <div class="mcc-card__body">
                                <form class="d-none" ref="fileDownloadForm" method="get">

                                    <input type="hidden" name="fileContent" id="fileContent" />
                                    <input type="hidden" name="fileName" id="fileName" />
                                    <input type="hidden" name="contentType" id="contentType" />
                                    <input type="hidden" ref="taskIDRef" id="processInstanceId" name="taskId" />
                                    <input type="hidden" name="fieldName" id="fieldName" />
                                    <button class="btn btn-success" type="submit" id="downloadFile" value="download"></button>
                                </form>
                                <div class="form-preview-parent">
                                    <div class="mcc-row" v-if="isExternal">
                                        <div class="mcc-col">
                                            <form ref="processForm" @submit="handleFormSubmit($event)" enctype="multipart/form-data" id="rendererForm" method="post" prevent-default captcha>
                                                <div id="render-canvas"></div>
                                                <div v-if="taskObj">
                                                    <div id="recaptcha"></div>
                                                    <span id="invalid-captcha"></span>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div class="mcc-row" v-if="!isExternal">
                                        <div class="mcc-col">
                                            <form novalidate ref="processForm" @submit="handleFormSubmit($event)" enctype="multipart/form-data" id="rendererForm" method="post" prevent-default>
                                                <div id="render-canvas"></div>
                                                <div class="overlay-div" v-if="taskObj.allowClaim || (!taskObj.allowUnClaim && !taskObj.allowClaim && !taskObj.isCompleted) || taskObj.isCompleted">
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <TaskHistoryComments ref="taskHistoryComment" v-if="fetchCall && !isStandalone" :users="userList" :taskId="taskId" :taskObj="taskObj" @updateCommentCount="handleCommentCount($event)"></TaskHistoryComments>
            <ProcessTaskDetails ref="processTaskDetails" v-if="fetchCall && !isStandalone" :taskObj="taskObj" :taskId="taskId">
            </ProcessTaskDetails>
            <Attachments ref="attachmentDialog" v-if="!isStandalone" :taskId="taskId" :taskObj="taskObj" @updateAttachmentCount="handleAttachmentCount($event)"></Attachments>
            <TaskOperations ref="taskOperations" v-if="fetchCall && !isStandalone" :taskId="taskId" :users="userList" :taskObj="taskObj" :routerURL="getRouterLinkURL(menu)"></TaskOperations>
            <div class="mcc-dialog-overlay">
                <dialog class="mcc-dialog mcc-dialog--primary mcc-dialog--sm" id="involvedUser-dialog" ref="involvedUserDialogRef">
                    <form novalidate id="involvedUser-dialog-form" ref="involveduserForm">
                        <section>
                            <div class="mcc-dialog__header">
                                <h2 class="h4">Involve people</h2>
                                <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.involvedUserDialogRef.close()">
                                    <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                                    <span class="mcc-button__label">Button</span>
                                </button>
                            </div>
                            <div class="mcc-dialog__body">
                                <div style="position:relative">
                                    <div v-show="!updateCall" class="spinner-overlay">
                                        <div class="spinner-background"></div>
                                        <div class="spinner-flex">
                                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="mcc-card">
                                        <div class="mcc-card__body">
                                            <h5 class="sub-title">Add people</h5>
                                            <div class="mfc-slim-select-wrapper mfc-form-input-container mfc-form-input-wrapper--width mu-position-relative dialogSlimSelect mu-mb-03" id="addPeopleSelectIdDiv">
                                                <label class="mfc-label--required" for="addPeopleSelect">Assignee</label>
                                                <div id="addPeopleSelectIdDiv"></div>
                                                <select :value="involvedAssignee" id="addPeopleSelect" @change="involvedAssignee = $event.target.value" required ref="delegate_assignee_select" name="assignee" block>
                                                </select>
                                            </div>
                                            <div class="mfc-textarea-wrapper mfc-form-input-container mfc-form-input-wrapper--width">
                                                <label class="mfc-label--required" for="Reason">Reason</label>
                                                <textarea ref="involveReasonText" :value="involvedReason" @input="involvedReason = $event.target.value" character-count="" name="involveReasonText" required="" maxlength="255" id="Reason"></textarea>
                                                <div class="mfc-invalid-feedback"></div>
                                                <div class="mfc-help-text mu-mt-00">
                                                    <span>You have {{255 - involvedReason.length}} characters remaining</span>
                                                </div>
                                            </div>
                                            <!-- <div class=" mu-d-flex mu-justify-content-end">
                                                <button type="button" @click="involveUserSubmit(false)" class="mcc-button mcc-button--soft-primary">
                                                    <mcc-icon name="plus_math" aria-hidden="true"></mcc-icon>
                                                    <span class="mcc-buttton__label"> Add</span>
                                                </button>
                                            </div> -->
                                        </div>
                                    </div>
                                    <div class="mu-mt-05">
                                        <mcc-data-table ref="commentTable" id="commentTableId"></mcc-data-table>
                                    </div>
                                </div>
                            </div>
                            <div class="mcc-dialog__footer">
                                <div class="mcc-button-group mcc-button-group--spaced">
                                    <button type="button" @click="$refs.involvedUserDialogRef.close()" class="mcc-button mcc-button--outline">Cancel</button>
                                    <button type="button" @click="involveUserSubmit(true)" class="mcc-button mcc-button--primary">Save</button>
                                </div>
                            </div>
                        </section>
                    </form>
                </dialog>
            </div>
        </div>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--primary mcc-dialog--xs" id="apiLookupSelectDataDialog" ref="apiLookupSelectDataDialog">
            <form novalidate id="apiLookupSelectDataDialogForm">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Select value</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.apiLookupSelectDataDialog.close()">
                            <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                            <span class="mcc-button__label">Button</span>
                        </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mfc-slim-select-wrapper ">
                            <select class="mfc-slim-select" ref="dataArrayAPI" no-search id="dataArraySelectCmp" name="dataArrayAPI" block label="Select value">
                                <option value>Select an option</option>
                            </select>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">
                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="$refs.apiLookupSelectDataDialog.close()">Cancel</button>
                            <button type="button" class="mcc-button mcc-button--primary" @click="setApiLookupValue()">Save</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog id="editGridPopup" ref="editHridPopupRef" class="mcc-dialog mcc-dialog--primary mcc-dialog--xs">
            <section>
                <form novalidate>
                    <div class="spinner-overlay d-none" id="grid-popup-wait">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                        </div>
                    </div>
                    <div class="mcc-dialog__header">
                        <h2 class="h4"></h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.editHridPopupRef.close()">
                            <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                            <span class="mcc-button__label">Button</span>
                        </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="row" id="grid-popup-content">
                            <div class="col">
                                <div class="mfc-input-wrapper">
                                    <input type="hidden" id="mode" name="" value="add">
                                    <input type="hidden" id="activeIndex" name="" value="-1">
                                </div>
                                <div class="container-fluid dataDiv" id="dataDiv">

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">
                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="closeEditGridDialog()">Cancel</button>
                            <button type="button" class="mcc-button mcc-button--primary" id="saveGridBtn" @click="$refs.editHridPopupRef.close()">Ok</button>
                        </div>
                    </div>
                </form>
            </section>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--primary mcc-dialog--xs" id="saveForLaterDialog" ref="saveForLaterDialogRef">
            <form novalidate id="saveForLaterDialogId">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Save as draft</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeDialog()">
                            <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                            <span class="mcc-button__label">Button</span>
                        </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mcc-row">
                            <div class="mcc-col">
                                <div v-if="updateDialog">
                                    <div class="mfc-input-wrapper mu-d-block mfc-form-input-container">
                                        <label for="partialFormInfoName" class="mfc-label--required">Name</label>
                                        <input type="text" :value="partialFormInfoName" @change="updateName($event)" ref="partialFormInfoName" :pattern="nameRegex" name="partialFormInfoName" id="partialFormInfoName" required="" maxlength="50">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">
                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" @click="closeDialog()" class="mcc-button mcc-button--outline">Close</button>
                            <button type="button" @click="saveForLater()" class="mcc-button mcc-button--primary">Save</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
</div>
</template>

<script>
import MyTaskListAPI from "../../services/MyTaskListAPI";
import AdminHttpAPI from "../../services/AdminHttpAPI";
import Utils from "../../script_utils";
import CustomDataList from "../../bindCustomDataList";
import TypeaheadUtils from "../../typeahead_utils";
import RepeatableUtils from "../../repeatable_utils";
import APILookupUtils from "../../apilookup";
import constants from "../../constants";
import constantMessages from "../../messages";
import TaskHistoryComments from "./dialogs/TaskHistoryComments";
import ProcessTaskDetails from "./dialogs/ProcessTaskDetails";
import Attachments from "./dialogs/Attachments";
import TaskOperations from "./dialogs/TaskOperations";
import GridUtils from "../../grid_utils";

import {
    EventBus
} from "../../services/event-bus";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '@/formvalid.js';

export default {
    name: "ViewTask",
    components: {
        TaskHistoryComments,
        ProcessTaskDetails,
        Attachments,
        TaskOperations
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["tasks.view"],
            descRegex: constantMessages.PATTERNS["description"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            fetchCall: false,
            taskId: "",
            claimUnclaimTitle: "Claim",
            taskObj: {
                processName: "Tasks",
                taskName: "",
                taskId: ""
            },
            nameRegex: constantMessages.PATTERNS["customName"],
            commentCount: 0,
            attachmentCount: 0,
            involvedUsersCount: 0,
            involvedUsers: [],
            involvedAssignee: "",
            involvedReason: "",
            taskEventData: [],
            updateSelect: false,
            formActionURL: "",
            downloadFormURL: "",
            updateCall: true,
            taskVariableList: null,
            taskVariableMap: null,
            menu: "",
            isLocationProcessEngine: true,
            userList: [],
            filteredInvolvedUsers: [],
            isStandalone: false,
            isExternal: false,
            partialFormInfoDTO: {},
            partialFormInfoName: "",
            updateDialog: false,
            claimSubmit: false,
            taskObjLoaded: false,
            addPeopleSlimInstance: null,
            dataArraySlimInstance: null,
        };
    },
    created() {
        window.signaturePad = {};

        this.title = "View task";
        this.taskId = this.$route.params.taskId;
        if (this.$route.params.standalone && this.$route.params.standalone == "standalone") {
            this.isStandalone = true;
        }
        if (this.$route.params.external && this.$route.params.external == "external") {
            this.isExternal = true;
        }
        if (this.isExternal) {
            this.formActionURL =
                constants.BASE_URL + `/standalone/external/tasksAPI/${this.taskId}/submitWithDropZone`;
            this.downloadFormURL = constants.BASE_URL + `/standalone/external/tasksAPI/downloadFile`;
        } else {
            this.formActionURL =
                constants.BASE_URL + `/tasks-api/${this.taskId}/submit`;
            this.downloadFormURL = constants.BASE_URL + `/tasks-api/download-file`;
        }
        if (this.$route.params.menuLocation != null) {
            this.isLocationProcessEngine = false;
            this.menu = Utils.capitalizeFirstLetter(this.$route.params.menuLocation);
        } else {
            this.menu = "Tasks";
        }
    },
    computed: {
        shouldShowBorderBottom() {
            return (
                (this.taskObj.isTaskClaimedAndNotCompleted && (this.taskObj.allowUnClaim || this.taskObj.isAdminUser)) ||
                (this.taskObj.allowReAssign && !this.taskObj.isCompleted) ||
                (this.taskObj.allowResolve && !this.taskObj.isCompleted)
            );
        },
    },
    mounted() {
        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=recaptchaCallback&render=explicit')
        document.head.appendChild(recaptchaScript)

        Utils.applyFixedHeaderConfiguration(this);

        this.getFormForTask();

        if (!this.isExternal) {
            MyTaskListAPI.getUsers().then(result => {
                this.userList = result;
            });
        }
        window.recaptchaCallback = this.recaptchaCallback;

        this.dataArraySlimInstance = new SlimSelect({
            select: '#dataArraySelectCmp',

        })
        this.addPeopleSlimInstance = new SlimSelect({
            select: '#addPeopleSelect',
            settings: {
                contentPosition: 'absolute',
                contentLocation: document.getElementById('addPeopleSelectIdDiv')
            }

        })
    },
    methods: {
        closeDropdown() {
            $('.mcc-dropdown').removeAttr('open');
        },
        showDialog() {
            this.updateDialog = true;
        },
        closeDialog() {
            this.$refs.saveForLaterDialogRef.close()
            this.updateDialog = false;
        },
        closeEditGridDialog() {
            $('#editGridPopup').parent().removeClass("mu-visible");
            this.$refs.editGridPopupRef.close();
        },
        recaptchaCallback() {
            if (this.taskObjChanged == false) {
                setTimeout(recaptchaCallback, 250);
                return;
            }
            if (this.isExternal) {
                grecaptcha.render("recaptcha", {
                    sitekey: this.taskObj.recaptchaKey,
                    callback: function () {
                        $("#invalid-captcha").text("");
                    }
                });
            }
        },
        involvedUserShowHandlerDialog() {
            this.$refs.involvedUserDialogRef.show()
            this.$refs.involveduserForm.classList.remove("ms-was-validated")
            this.involvedUserShowHandler()
        },
        updateSlimSelectOptions() {
            const options = [{
                    text: '',
                    placeholder: true
                },
                ...this.filteredInvolvedUsers.map((user) => ({
                    text: user.firstName,
                    value: user.username
                })),
            ];
            this.addPeopleSlimInstance.setData(options);
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.partialFormInfoName), constantMessages.MESSAGES["error.name.required"])
                self.$refs.partialFormInfoName.classList.add("ms-is-invalid");
              
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.partialFormInfoName), constantMessages.MESSAGES["error.name.length"])
                self.$refs.partialFormInfoName.classList.add("ms-is-invalid");
               
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.partialFormInfoName), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.partialFormInfoName.classList.add("ms-is-invalid");
               
            }
            self.partialFormInfoName = event.target.value;
        },
        getFormForTask() {
            let self = this;
            MyTaskListAPI.getFormForTask(this.taskId, this.isExternal)
                .then(result => {
                    self.taskObj = result;
                    this.taskObjLoaded = true;
                    if (!self.isExternal) {
                        self.taskObj["email"] = "";
                        if (self.taskObj.assignee != null && self.taskObj.assignee != "") {
                            self.taskObj["email"] = self.getUserEmail(self.taskObj.assignee);
                        }
                        self.claimUnclaimTitle = self.taskObj.allowClaim ?
                            "Claim" :
                            self.taskObj.allowUnClaim ?
                            "Unclaim" :
                            "Claim/Unclaim";

                    }
                    if (self.taskObj.partialFormInfoDTO != null) {
                        self.partialFormInfoDTO = self.taskObj.partialFormInfoDTO;
                    }
                    self.fetchCall = true;
                    let pageTitle = self.taskObj.processName + " - " + self.taskObj.taskName;
                    EventBus.$emit("update-pageTitle", pageTitle);
                })
                .finally(() => {
                    self.generateForm(self.taskObj.formRenderJson);
                    if (!self.taskObj.isCompleted && !self.isExternal) {
                        self.getTaskData(false);
                    }
                });
        },
        afterTaskDataLoad() {
            // Set disabled state
            if (
                this.taskObj.isCompleted ||
                (!this.taskObj.allowUnClaim &&
                    !this.taskObj.allowClaim &&
                    !this.taskObj.isCompleted) ||
                (this.taskObj.allowClaim &&
                    !this.taskObj.isAdminUser &&
                    this.taskObj.isUserInitiator)
            ) {
                setTimeout(function () {
                    $("#dropdown_btn .mcc-button-group > .mcc-button button").attr("disabled", "disabled");
                }, 0);
            }
        },
        handleCommentCount(count) {
            this.commentCount = count;
        },
        handleAttachmentCount(count) {
            this.attachmentCount = count;
        },
        involvedUserShowHandler() {
            $("#involvedUser-dialog-form")[0].reset();
            this.involvedReason = "";
            this.$refs.involveReasonText.value = "";
            this.involvedAssignee = "";
            setTimeout(() => {
                self.$refs.involveReasonText.classList.remove("ms-is-invalid")
                self.$refs.delegate_assignee_select.classList.remove("ms-is-invalid")
            }, 0);
            this.getTaskData(true);
        },
        setCanvasSize() {
            $('canvas').each((i, Ele) => {
                let canvasEle = $(Ele);
                let offsetWidth = canvasEle[0].offsetWidth;
                if (offsetWidth != 0) {
                    $(Ele).attr("width", canvasEle[0].offsetWidth);
                    $(Ele).attr("height", canvasEle[0].offsetHeight);
                }
            });
        },
        getTaskData(loadTable) {
            let self = this;
            MyTaskListAPI.getInvolvedUsers(this.taskId)
                .then(result => {
                    result.data.forEach(function (obj, index) {
                        let actionsObj = {
                            deleteAction: {
                                hidden: obj.type != "participant"
                            }
                        };
                        obj["email"] = self.getUserEmail(obj.user);
                        obj["actions"] = actionsObj;
                    });
                    self.involvedUsers = result.data;
                    self.involvedUsersCount = self.involvedUsers.length;
                    self.filterUsersForInvolvedDialog();
                })
                .finally(() => {
                    if (this.addPeopleSlimInstance)
                        this.addPeopleSlimInstance.destroy()
                    this.addPeopleSlimInstance = new SlimSelect({
                        select: '#addPeopleSelect',
                        settings: {
                            contentPosition: 'absolute',
                            contentLocation: document.getElementById('addPeopleSelectIdDiv')
                        }
                    })
                    setTimeout(() => {
                        this.updateSlimSelectOptions()
                    }, 0);
                    if (loadTable) {
                        self.initInvolvedUsersTable();

                        setTimeout(() => {
                            $(this.$refs.delegate_assignee_select).removeAttr("invalid");
                        }, 250);
                    }
                });
        },
        getUserEmail(name) {
            if (name != "") {
                let userEmail = this.userList.filter(a => {
                    return a.username == name;
                });
                if (userEmail != null && userEmail.length > 0) {
                    return userEmail[0].email;
                }
            }
            return "";
        },
        isUserPresent(name) {
            let mapOfName = this.involvedUsers.map(a => a.user);
            return mapOfName.indexOf(name) == -1;
        },
        filterUsersForInvolvedDialog() {
            let self = this;
            this.filteredInvolvedUsers = this.userList.filter(a => {
                return self.isUserPresent(a.username);
            });

        },
        generateForm(formJson) {
            this.updateCall = false;
            setTimeout(() => {
                window.generatePreview(JSON.parse(formJson), $("#render-canvas"), 1);
                this.afterFormRender();
                this.$refs.taskIDRef.value = this.taskId;
                $(this.$refs.fileDownloadForm).attr("action", this.downloadFormURL);
                $(this.$refs.fileDownloadForm).find("form").attr("action", this.downloadFormURL);
            }, 0)

        },
        populateAPILookup() {
            $("#render-canvas").find(".form-group.row[apilookupcontainer]").find("button").each(function () {
                $(this).on('click', () => {
                    APILookupUtils.renderApiLookupDataField(this);
                })
            });
        },
        afterFormRender() {
            let self = this;
            // if (this.taskObj.allowClaim || (!this.taskObj.allowUnClaim && !this.taskObj.allowClaim && !this.taskObj.isCompleted) || this.taskObj.isCompleted) {
            $("#render-canvas .dropzone").each(function () {
                Utils.bindDropzone(
                    this,
                    $(this).attr("name"),
                    self.formActionURL,
                    true
                );
            });
            Utils.applyFileUploadValidations("render-canvas");
            CustomDataList.populateDataListData();
            this.populateAPILookup();
            setTimeout(function () {
                self.setCanvasSize();
                Utils.updateFormUsingProcessVariables(
                    self.taskObj.variableList,
                    self.taskObj.variableMap
                );
                let dataJSON = self.taskObj.hasOwnProperty("dataJson") ?
                    self.taskObj.dataJson : {};
                RepeatableUtils.renderRepeatableRows(dataJSON);
                setTimeout(() => {
                    // window.applyDecimalValidation($("#render-canvas"), false);
                }, 0);
                GridUtils.renderEditableGrid(dataJSON);
                Utils.renderFileDownloadLinks(dataJSON);
                setTimeout(function () {
                    // TypeaheadUtils.updateTypeAheadData();
                    if ($("[data-grid='true']") == null || $("[data-grid='true']").length == 0) {
                        TypeaheadUtils.updateDynamicTypeAheadData().then(() => {
                            self.updateCall = true;
                        });
                    }
                    window.applyConditionalRendering($("#render-canvas"));
                    window.applyCustomConditionalRendering($("#render-canvas"));
                }, 0);

                self.handleSignatureComponetData(dataJSON);
                if ($("[data-grid='true']") != null && $("[data-grid='true']").length > 0) {
                    self.updateCall = true;
                }
                if (self.taskObj.allowClaim && !self.taskObj.isCompleted) {
                    $('.mcc-tabs ul.mu-mb-05 > li').css('z-index', 4);
                }
                self.afterTaskDataLoad();
            }, 2000);
            // }
            setTimeout(function () {
                window.applyConditionalRendering($("#render-canvas"));
                window.applyCustomConditionalRendering($("#render-canvas"));
            }, 3000)

        },
        handleSignatureComponetData(dataJSON) {
            if (window.signaturePad) {
                let parsedDataJSON = JSON.parse(dataJSON);
                for (let jsonObj in parsedDataJSON) {
                    //if(jsonObj.indexOf("signature") !== -1) {
                    $.each(window.signaturePad, function () {
                        let signatureCanvasEleName = this.canvas.getAttribute("name");
                        if (signatureCanvasEleName === jsonObj) {
                            this.fromData(JSON.parse(JSON.parse("\"" + parsedDataJSON[jsonObj] + "\"")));
                        }
                    });
                    //}
                }
            }
        },
        handleSaveForLater() {
            let self = this;
            if (self.partialFormInfoDTO.id != null) {
                self.partialFormInfoName = self.partialFormInfoDTO.name;
            } else {
                self.partialFormInfoName = "";
            }
            self.showDialog()
            self.$refs.saveForLaterDialogRef.show();
        },
        saveForLater() {
            let self = this;

            let form = $('#saveForLaterDialogId')

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            self.partialFormInfoDTO.name = self.partialFormInfoName;
            let url = "update";
            self.updateCall = false;
            let disabled = $(this.$refs.processForm).find(':disabled').removeAttr('disabled');
            let formData = $(this.$refs.processForm).serializeArray();
            disabled.attr('disabled', 'disabled');
            let formDataArray = [];
            Utils.updateFormDataForCheckbox(formData, formDataArray);
            let partialFormDatas = [];
            Utils.updateDateValuesForDraft(formDataArray);
            for (let key in formDataArray) {
                let partialFormData = {};
                if (TypeaheadUtils.isTypeahead(formDataArray[key].name)) {
                    let formValue = TypeaheadUtils.getTypeAheadFieldValue(
                        TypeaheadUtils.getElementByName(formDataArray[key].name)
                    );
                    partialFormData.varName = formDataArray[key].name;
                    partialFormData.varValue = formValue;
                } else {
                    partialFormData.varName = formDataArray[key].name;
                    partialFormData.varValue = formDataArray[key].value;
                }
                if (partialFormData.varName.startsWith("oldRepeatableRow") && self.taskObj.hasOwnProperty(partialFormData.varName) && self.taskObj[partialFormData.varName] != null) {
                    partialFormData.varValue = self.taskObj[partialFormData.varName];
                }
                if (partialFormData.varName == "oldGridRow" && self.taskObj.hasOwnProperty("oldGridRow") && self.taskObj.oldGridRow != null) {
                    partialFormData.varValue = self.taskObj.oldGridRow;
                }
                partialFormDatas.push(partialFormData);
            }
            if (self.partialFormInfoDTO.id == null) {
                self.partialFormInfoDTO.processDefinitionId = self.taskObj.processId;
                self.partialFormInfoDTO.processInstanceId = self.taskObj.processInstanceId;
                self.partialFormInfoDTO.taskId = self.taskObj.taskId;
                self.partialFormInfoDTO.processDefinitionName = self.taskObj.processName;
                self.partialFormInfoDTO.taskName = self.taskObj.taskName;
                url = "save";
            }
            self.partialFormInfoDTO.partialFormDatas = partialFormDatas;
            MyTaskListAPI.saveForLater(url, self.partialFormInfoDTO)
                .then(response => {
                    if (response) {
                        if (response.data == "error.input.owasp.error") {
                            displayErrorMessage($(self.$refs.partialFormInfoName), constantMessages.MESSAGES[response.data])
                            self.$refs.partialFormInfoName.classList.add("ms-is-invalid")
                        } else if (response.data == "error.forbidden" || response.data == "error.save.partialFormData" || response.data == "error.update.partialFormData") {
                            EventBus.$emit("error-notification", {
                                msg: constantMessages.MESSAGES[response.data]
                            });
                        } else {
                            self.partialFormInfoDTO = response;
                            self.$refs.saveForLaterDialogRef.close();
                            if (self.isStandalone) {
                                EventBus.$emit("success-notification", {
                                    msg: constantMessages.MESSAGES["task.draft.save.success.standalone"]
                                });
                            } else {
                                EventBus.$emit("success-notification", {
                                    msg: constantMessages.MESSAGES["task.draft.save.success"]
                                });
                            }
                        }

                    }
                })
                .finally(() => {
                    self.updateCall = true;
                });
        },
        handleFormSubmit(e) {
            let self = this;
            if (self.isExternal) {
                let recaptcha = grecaptcha.getResponse();
                if (recaptcha.length == 0) {
                    $("#invalid-captcha").text("Captcha check is required");
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
            }
            // let mosaicData = e.detail.data;
            let form = $(this.$refs.processForm);
            let formDataArray = form.serializeArray();
            if (e.submitter.attributes.ignoreformvalidation === undefined) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            let ignoreValidation = e.submitter.attributes.ignoreformvalidation.value;
            if (!form[0].checkValidity() && ignoreValidation != 'true') {
                e.preventDefault();
                e.stopPropagation();
                form.addClass('ms-was-validated');
                this.switchTab(e);
            } else {
                let form_data = new FormData();
                // Utils.updateDatepickerValues(mosaicData, formDataArray);
                if (Utils.appendDropzoneDataExternal(form_data) && TypeaheadUtils.validateValueOfTypeahead() && TypeaheadUtils.validateTypeaheadMinValues() && Utils.validateEditableGrid()) {
                    this.updateCall = false;
                    let fileInputs = $("#rendererForm input[type=file]");
                    for (const fileInput of fileInputs) {
                        for (const file of fileInput.files) {
                            form_data.append(fileInput.name, file);
                        }
                    }
                    for (let key in formDataArray) {
                        if (TypeaheadUtils.isTypeahead(formDataArray[key].name)) {
                            let formValue = TypeaheadUtils.getTypeAheadFieldValue(
                                TypeaheadUtils.getElementByName(formDataArray[key].name)
                            );
                            if ($('[name="' + formDataArray[key].name + '"]').find("input").length > 0 && $('[name="' + formDataArray[key].name + '"]').find("input").attr("type") == "number") {
                                form_data.append(formDataArray[key].name + "_type", "double");
                            }
                            form_data.append(formDataArray[key].name, formValue);
                        } else if (formDataArray[key].name.startsWith("oldRepeatableRow") && self.taskObj.hasOwnProperty(formDataArray[key].name) && self.taskObj[formDataArray[key].name] != null) {
                            form_data.append(formDataArray[key].name, self.taskObj[formDataArray[key].name]);
                        } else if (formDataArray[key].name == "oldGridRow" && self.taskObj.hasOwnProperty("oldGridRow") && self.taskObj.oldGridRow != null) {
                            form_data.append(formDataArray[key].name, self.taskObj.oldGridRow);
                        } else {
                            if ($('[name="' + formDataArray[key].name + '"]').find("input").length > 0 && $('[name="' + formDataArray[key].name + '"]').find("input").attr("type") == "number") {
                                form_data.append(formDataArray[key].name + "_type", "double");
                            }
                            form_data.append(formDataArray[key].name, formDataArray[key].value);
                        }
                    }

                    let btnObj = $(document.activeElement);
                    // if ($(btnObj).prop("tagName") == "BUTTON") {
                    //     btnObj = $(btnObj).closest("mosaic-button");
                    // } else {
                    //     btnObj = $("#render-canvas mosaic-button[submit]");
                    // }
                    if (btnObj != null && btnObj.length > 0) {
                        form_data.append($(btnObj).attr("name"), $(btnObj).attr("value"));
                    }
                    if (window.signaturePad) {
                        $.each(window.signaturePad, function () {
                            if (!this.canvas.hasAttribute("data-protected")) {
                                form_data.append(this.canvas.getAttribute("name"), JSON.stringify(this.toData()));
                            }
                        });
                    }
                    e.preventDefault();
                    if (self.isExternal) {
                        let recaptcha = grecaptcha.getResponse();
                        AdminHttpAPI.verifyCaptcha(recaptcha).then(response => {
                            if (response) {
                                self.submitForm(this.formActionURL, form_data);
                            } else {
                                grecaptcha.reset();
                                self.updateCall = true;
                                EventBus.$emit("error-notification", {
                                    msg: "There is a problem with reCaptcha configuration. Please contact system administrator"
                                });
                            }
                        });
                    } else {
                        self.submitForm(this.formActionURL, form_data);
                    }
                } else {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
        },
        switchTab(e) {
            $("#" + $("#" + document.querySelectorAll(":invalid")[1].id).parents(".newClass")[0].id).trigger('click');
            $("#" + document.querySelectorAll(":invalid")[1].id).focus();
        },
        submitForm(submitURL, formData) {
            let self = this;
            MyTaskListAPI.submitTask(submitURL, formData)
                .then(response => {
                    if (response.status == "success") {
                        if (!self.isExternal) {

                            if (!this.isStandalone) {
                                EventBus.$emit("success-notification", {
                                    msg: response.message
                                });
                            }
                            if (response.nextTaskId != null && response.nextTaskId != "") {
                                if (this.isStandalone) {
                                    self.$router.push(
                                        self.CONTEXT_PATH + "/redirectTo/" + response.nextTaskId
                                    );
                                } else {
                                    self.$router.push(
                                        self.CONTEXT_PATH +
                                        "/tasks/viewtask/assigned/" +
                                        response.nextTaskId
                                    );
                                }
                            } else {
                                if (this.isStandalone) {
                                    this.$router.push({
                                        path: this.CONTEXT_PATH +
                                            "/standalone/external/task/success",
                                        name: "StartSuccess",
                                        params: {
                                            otherProps: {
                                                completionMessage: response.message,
                                            }
                                        }
                                    });
                                } else {
                                    self.$router.push(self.getRouterLinkURL(self.menu));
                                }

                            }
                        } else {
                            this.$router.push({
                                path: this.CONTEXT_PATH +
                                    "/standalone/external/task/success",
                                name: "StartSuccess",
                                params: {
                                    otherProps: {
                                        completionMessage: response.message,
                                    }
                                }
                            });
                        }
                    } else if (
                        response.message == "fileupload.maxsize" ||
                        response.message == "fileupload.scan.error" || response.message === "fileupload.exe.error"
                    ) {
                        EventBus.$emit("error-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                    } else if (response.message != "") {
                        let errorMsg =
                            constantMessages.MESSAGES["application.form.submit.failure"];
                        let systemAdminEmail = response.systemAdminEmail;
                        if (systemAdminEmail != null && systemAdminEmail.trim() != "") {
                            errorMsg =
                                constantMessages.MESSAGES[
                                    "application.form.submit.failure.email"
                                ] +
                                '<a href="mailto:' +
                                systemAdminEmail +
                                '" target="_top">' +
                                constantMessages.MESSAGES[
                                    "application.form.submit.failure.link"
                                ] +
                                "</a>";
                        }
                        EventBus.$emit("error-notification", {
                            msg: errorMsg
                        });
                    }
                })
                .finally(() => {
                    self.updateCall = true;
                });
        },
        setApiLookupValue() {
            APILookupUtils.setApiLookupValue(this.$refs.dataArrayAPI.value);
            this.$refs.apiLookupSelectDataDialog.close()
        },
        performInvolveUserOperation(operationType) {
            let self = this;
            self.updateCall = false;
            let obj = {
                taskName: this.taskObj.taskName,
                processId: this.taskObj.processId,
                processInstanceId: this.taskObj.processInstanceId,
                assignee: this.involvedAssignee,
                message: this.involvedReason,
                processName: this.taskObj.processName
            };
            let isError = false;
            MyTaskListAPI.delegateReassigneeTask(this.taskId, obj, operationType)
                .then(response => {
                    if (response.error) {
                        if (response.message == "tasks.involveUser.error.email") {
                            EventBus.$emit("warning-notification", {
                                msg: constantMessages.MESSAGES[response.message]
                            });
                        } else {
                            EventBus.$emit("error-notification", {
                                msg: constantMessages.MESSAGES[response.message]
                            });
                            isError = true;
                        }
                    } else {
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                        self.involvedUsersCount = response.data;
                    }
                })
                .finally(() => {
                    self.updateCall = true;

                });
        },
        involveUserSubmit(isSubmit) {
            let form = $('#involvedUser-dialog-form')

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            this.performInvolveUserOperation("involve-user");
            if (!isSubmit)
                this.$refs.involvedUserDialogRef.close()
            else
                this.involvedUserShowHandler()
        },
        // involveUser
        getRouterLinkURL(menuName) {
            switch (menuName) {
                case "Assigned":
                    return this.CONTEXT_PATH + "/tasks/assigned";
                case "Unclaimed":
                    return this.CONTEXT_PATH + "/tasks/unclaimed";
                case "All involved":
                    return this.CONTEXT_PATH + "/tasks/involvingme";
                case "Tasks":
                    return this.CONTEXT_PATH + "/processengine/tasks";
                case "Drafts":
                    return this.CONTEXT_PATH + "/tasks/drafts";
            }
        },
        getViewTaskURL(menuName) {
            switch (menuName) {
                case "Assigned":
                    return this.CONTEXT_PATH + "/tasks/viewtask/assigned";
                case "Unclaimed":
                    return this.CONTEXT_PATH + "/tasks/viewtask/unclaimed";
                case "All involved":
                    return this.CONTEXT_PATH + "/tasks/viewtask/all involved";
                case "Tasks":
                    return this.CONTEXT_PATH + "/processengine/tasks";
                case "Drafts":
                    return this.CONTEXT_PATH + "/tasks/viewtask/drafts";
            }
        },
        performClaimUnClaimResolve(operation) {
            let self = this;
            this.updateCall = false;
            MyTaskListAPI.claimUnclaimOperation(this.taskId, operation)
                .then(response => {
                    if (response.error) {
                        this.getFormForTask();
                    } else {
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                        // if not claim & check if request from headless form
                        if (operation != "claim" && !self.claimSubmit) {
                            self.$router.push(self.getRouterLinkURL(self.menu));
                            // if unclaim & check if request from headless form
                        } else if (operation == "unclaim" && self.claimSubmit) {
                            this.getFormForTask();
                        } else {
                            // Claim Task
                            if (self.menu == "Unclaimed") {
                                self.$router.push(
                                    self.getViewTaskURL("Assigned") + `/${self.taskId}`
                                );
                            } else if (self.claimSubmit) {
                                this.getFormForTask();
                            } else {
                                self.$router.push(
                                    self.getViewTaskURL(self.menu) + `/${self.taskId}?reload`
                                );
                            }
                        }
                    }
                })
                .finally(() => {
                    self.updateCall = true;
                });
        },
        handleClaimUnclaim(value, formType) {
            if (formType)
                this.claimSubmit = true;
            if (value == "Claim" || value == "Unclaim") {
                this.performClaimUnClaimResolve(
                    this.taskObj.allowClaim ? "claim" : "unclaim"
                );
            }
        },
        performResolveOperation(e) {
            this.performClaimUnClaimResolve("resolve");
        },
        redirectToEngineTaskList() {
            localStorage.setItem("AllTasks", "AllTasks");
            this.$router.push(this.getRouterLinkURL("Tasks"));
        },
        redirectToTaskList() {
            let pageName = "InvolvingMeTasks";
            if (this.menu == "Assigned") {
                pageName = "Assigned";
            } else if (this.menu == "Unclaimed") {
                pageName = "Unclaimed";
            }
            localStorage.setItem(pageName, pageName);
            this.$router.push(this.getRouterLinkURL(this.menu));
        },
        initInvolvedUsersTable() {
            let self = this;
            const table = document.getElementById("commentTableId");
            this.tableObj = window.tableFactory.create(table, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No users found</p>',
                columnSearch: false,
                pageSize: 10,
                fixedHeight: true,
                debounceTime: 1000,
                totalCount: self.involvedUsers.length,
                schema: {
                    properties: {
                        user: {
                            type: "string",
                            title: "User",
                            sortable: true,
                            format: "email",
                            template: `<a href="mailto:{{email}}?subject=Re: ${self.taskObj.taskName}" rel="noopener">{{user}}</a>`
                        },
                        type: {
                            type: "string",
                            title: "Type",
                            sortable: true,
                        },
                        actions: {
                            type: "object",
                            title: "Actions",
                            properties: {
                                deleteAction: {
                                    type: "string",
                                    format: "button",
                                    title: "",
                                    icon: "trash",
                                    color: "danger",
                                    iconOnly: true
                                }
                            }
                        }
                    }
                },
                data: () => {
                    return self.involvedUsers;
                },
                onAction: (table, action, [{
                    index,
                    rowData,
                    value
                }]) => {
                    if (action == "deleteAction") {
                        self.updateCall = false;
                        let obj = {
                            selectedUser: rowData.user
                        };
                        let isError = false;
                        MyTaskListAPI.deleteInvolvedUser(self.taskId, obj)
                            .then(response => {
                                if (response.error) {
                                    EventBus.$emit("error-notification", {
                                        msg: constantMessages.MESSAGES[response.message]
                                    });
                                    isError = true;
                                } else {
                                    EventBus.$emit("success-notification", {
                                        msg: constantMessages.MESSAGES[response.message]
                                    });
                                }
                            })
                            .finally(() => {
                                self.updateCall = true;
                                if (!isError) {
                                    self.getTaskData(true);
                                }
                            });
                    }
                }
            });
        },
        handlePrintForm() {
            window.print();
        }
    }
}
</script>

<style scoped>
.form-designer-component {
    @import "/formdesigner/css/commonStyles.css";
    @import "/formdesigner/styles.css";
}
</style>
<style scoped>
.overlay-div {
    background-color: #e9ecef;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    z-index: 2;
    opacity: 0.5;
}

.canvas {
    grid-area: 1 / 1;
}

.parent-canvas {
    display: grid;
}

.form-preview-parent {
    position: relative;
}

.taskerHeaderMargin {
    margin: 0 30px 0px 30px !important;
}

[v-cloak] {
    display: none;
}

#render-canvas .mcc-card .container-fluid,
#render-canvas .mcc-tabs .container-fluid {
    padding: 0;
}
</style>
